import React, { Component, PureComponent } from "react";
import styled from "styled-components";
import { Color, GlobalColorPalette, ColorProps, ChartProps, Chart, ICSS, ICSSProps } from "@gago/frame";
import MyGaugeCopy from "./my-gauge-copy";
import GaugeLegend from "./gauge-legend";

// tslint:disable:variable-name ter-max-len
const GaugeAntdBody = styled.div<ColorProps<GlobalColorPalette>>`
  width: 100%;
  height: 100%;
  .my-gauge-copy{
    height: 140px;
    width: 140px;
    margin: 0 auto;
  }
`;

type Gprops = ColorProps<GlobalColorPalette> & ChartProps<1, 5> & ICSSProps;

/**
 * 大屏仪表盘  只针对数据比例(讨个壳)
 * @author 马俊峰
 * @date 2020-06-29
 * @export
 * @class GaugeAntd
 * @extends {PureComponent<Gprops>}
 * @implements {Color}
 * @implements {Chart<1, 5>}
 * @implements {ICSS}
 */
export class GaugeAntd extends PureComponent<Gprops> implements Color, Chart<1, 5>, ICSS {
  render() {
    const { style, className, colorPalette, chartData } = this.props;
    const { suffix, data } = chartData;
    return (
      <GaugeAntdBody colorPalette={colorPalette} style={style} className={className}>
        <MyGaugeCopy
          className="my-gauge-copy"
          colorPalette={colorPalette}
          chartData={chartData}
        />
        <GaugeLegend
          colorPalette={colorPalette}
          currentValue={data[0][5]}
          currentSuffix={suffix && suffix[5] || "---"}
          ratio={data[0][6]}
        />
      </GaugeAntdBody>
    );
  }
}
